module.exports = __webpack_public_path__ + "static/media/15-bnner.798f2499.mp3";